import { render, staticRenderFns } from "./CASEJSONView.vue?vue&type=template&id=08714be4&"
import script from "./CASEJSONView.vue?vue&type=script&lang=js&"
export * from "./CASEJSONView.vue?vue&type=script&lang=js&"
import style0 from "./CASEJSONView.vue?vue&type=style&index=0&id=08714be4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
